import React from "react";
import {
  alpha,
  Box,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";

// Icons
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

export default function DeliveryServiceListRow({
  index,
  deliveryService,
  editAction,
  deleteAction,
}) {
  const theme = useTheme();

  // Animation variants
  const rowVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
    hover: {
      scale: 1.01,
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      backgroundColor: alpha(theme.palette.background.paper, 0.95),
    },
  };

  return (
    <Box sx={{ mb: 2 }}>
      <motion.div
        variants={rowVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        whileHover="hover"
        transition={{ duration: 0.2 }}
      >
        <Paper
          elevation={1}
          sx={{
            p: 2,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            transition: "all 0.2s ease",
            border: "1px solid",
            borderColor: alpha(theme.palette.divider, 0.1),
            backgroundColor: theme.palette.background.paper,
          }}
        >
          {/* Service icon/avatar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: 1.5,
              mr: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
            }}
          >
            <LocalShippingIcon />
          </Box>

          {/* Service Info */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" fontWeight={500}>
                {deliveryService.name}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {deliveryService.phone || "Sem telefone disponível"}
            </Typography>
          </Box>

          {/* Actions */}
          <Box sx={{ display: "flex" }}>
            <Tooltip title="Editar serviço">
              <IconButton
                onClick={editAction}
                sx={{
                  color: theme.palette.primary.main,
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  mr: 1,
                  "&:hover": {
                    bgcolor: alpha(theme.palette.primary.main, 0.2),
                  },
                }}
                component={motion.button}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Remover serviço">
              <IconButton
                onClick={deleteAction}
                sx={{
                  color: theme.palette.error.main,
                  bgcolor: alpha(theme.palette.error.main, 0.1),
                  "&:hover": {
                    bgcolor: alpha(theme.palette.error.main, 0.2),
                  },
                }}
                component={motion.button}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Paper>
      </motion.div>
    </Box>
  );
}
